document.addEventListener('click', (e) => {
  const anchor = e.target.closest('a[href^="#"], a[href^="/#"]');
  if (!anchor) return;
  if (anchor.closest('.jdgm-widget, .jdgm-rev-widg, [class*="jdgm-"]')) return;

  const rawHref = anchor.getAttribute('href') || '';
  const hash = rawHref.startsWith('/#') ? rawHref.slice(1) : rawHref;
  const id = hash.slice(1);
  if (!id) return;

  e.preventDefault();
  const target = document.getElementById(id);

  if (!target && window.location.pathname !== '/') {
    window.location.href = '/' + hash;
    return;
  }

  history.pushState('', document.title, window.location.pathname + window.location.search);

  if (!target) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  document.querySelector('.drawer-open .header__btn-menu')?.click();
  target.scrollIntoView({ behavior: 'smooth' });
});

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();

    this.contentMenu = this.querySelector('.header__menu-mobile');
    this.header = document.querySelector('#section-header');
    this.btnMenu = document.querySelector('.header__btn-menu');
    this.closeBtnMenu = document.querySelector('.header__close-btn');
    this.btnHeaderEnd = document.querySelector('.btn-header');
    this.headerLogo = document.querySelector('.header__logo');

    this.btnMenu.addEventListener('click', () => this.toggleClass());
    this.closeBtnMenu?.addEventListener('click', () => this.toggleClass());

    this.handleOutsidePointer = (e) => {
      if (!this.classList.contains('open')) return;
      if (!window.matchMedia('(max-width: 1024px)').matches) return;
      if (this.header && this.header.contains(e.target)) return;
      this.toggleClass();
    };

    document.addEventListener('click', this.handleOutsidePointer, true);
    document.addEventListener('touchstart', this.handleOutsidePointer, true);

    this.handleKeyDown = (e) => {
      if (e.key === 'Escape' && this.classList.contains('open')) {
        this.toggleClass();
      }
    };
    window.addEventListener('keydown', this.handleKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsidePointer, true);
    document.removeEventListener('touchstart', this.handleOutsidePointer, true);
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  initSlider() {
    if (document.querySelectorAll('.swiper-header .swiper-slide').length < 2) return;
    this.swiper = new Swiper('.swiper-header', {
      slidesPerView: 1,
      spaceBetween: 6,
      slidesOffsetAfter: 0,
      direction: 'vertical',
      loop: true,
      autoplay: {
        enabled: true,
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      speed: 1500,
    });
  }

  toggleClass() {
    if (this.classList.contains('open')) {
      this.style.maxHeight = '0';
      this.classList.remove('open');
      this.header?.classList.remove('drawer-open');
    } else {
      const height = this.contentMenu.scrollHeight;
      this.style.maxHeight = height + 'px';
      this.classList.add('open');
      this.header?.classList.add('drawer-open');
    }
  }
}

customElements.define('header-menu', HeaderMenu);
